import TextTruncate from './TextTruncate'

export default TextTruncate
